import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36093dc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "hero",
  ref: "heroRef"
}
const _hoisted_2 = { class: "hero__image_container" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  class: "hero__breadcrumb",
  href: "/nieuws"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("terug naar nieuws")
const _hoisted_6 = { class: "hero__date" }
const _hoisted_7 = { class: "hero__title" }
const _hoisted_8 = {
  key: 0,
  class: "hero__introduction"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(`hero__image remove-mix-blend-mode ${
          _ctx.gradient ? 'hero__image--with-gradient' : ''
        }`),
        "data-scrolltrigger-start": "0",
        style: _normalizeStyle(`background-image:url(${_ctx.image})`)
      }, null, 6)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", _hoisted_4, [
        _createVNode(_component_Icon, {
          type: "arrow-left",
          class: "hero__breadcrumb__icon"
        }),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.date), 1),
      _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.title), 1),
      (_ctx.introduction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.introduction), 1))
        : _createCommentVNode("", true)
    ])
  ], 512))
}